
















import { bookGoodsModelProvider } from '../model'
import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()

      isCoupon = computed(() => this.bookGoodsModel.value.isCoupon)
    },
)
